<ion-header>
    <ion-toolbar class="ion-padding-end">
        <ion-title>Identidade Consumidor</ion-title>

        <ion-button style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end" (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>

    </ion-toolbar>
</ion-header>
<ion-content class="ion-padding padding-horizontal">

    <div #Consumerpdf style="width: 720px; padding: 20px; margin: auto;">

        <ion-grid>

            <ion-row style="min-height: 400px;">
                <ion-col class="flex-justify-center">
                    <qr-code [value]="Code" size="300" errorCorrectionLevel="M" />
                </ion-col>

                <ion-col size="12" class="flex-justify-center">
                    <ion-label class="ion-text-center" style="min-width: 400px">
                        <ion-text class="ion-text-center">{{Data?.Name}}</ion-text>
                        <p class="ion-text-center ion-padding-top"><b>{{CardNumber}}</b></p>
                    </ion-label>
                </ion-col>
            </ion-row>
            <ion-row class="ion-margin-vertical ion-padding">
                <ion-col>

                    <div id="instructions">
                        <h3 class="ion-padding-horizontal ion-text-center ion-padding-bottom">Instruções de Utilização
                        </h3>

                        <p style="font-size: 12px; line-height: 1.6;">
                            Para utilizar o seu cartão, apresente o <strong>QR Code</strong> ao
                            comerciante ou, em alternativa, indique o
                            <strong>número do cartão</strong>.<br />Após esta etapa, o comerciante poderá
                            aceder aos seus dados para verificar a sua elegibilidade e os
                            <strong>benefícios associados</strong> ao cartão.
                        </p>
                        <p style="font-size: 12px; line-height: 1.6;">
                            Recomendamos que <strong>descarregue e imprima este documento</strong> para
                            ter consigo sempre que necessário.
                        </p>
                    </div>
                </ion-col>
            </ion-row>


        </ion-grid>
    </div>

</ion-content>
<ion-footer>
    <ion-toolbar class="ion-padding-end">
        <ion-buttons slot="end">
            <ion-button fill="solid" color="primary" (click)="GeneratePdf($event)">Descarregar</ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-footer>
